import React from 'react';
import { Navigate } from 'react-router-dom';

/** Legacy route: service availability lives under Push notifications. */
const InProgressNotifyPage: React.FC = () => <Navigate to="/push-notifications" replace />;

export default InProgressNotifyPage;
